import * as React from "react";
import DefaultMapPage from "../../../common/DefaulMapPage/DefaultMapPage";
import { COUNTRIES_COUNT } from "../../../../constants/countries";

const ActiveCountries = () => (
  <DefaultMapPage title={`${COUNTRIES_COUNT} countries`}
                  subtitle='Real Estate Globally'
                  pageInfo='01 - hello' />

);

export default ActiveCountries;
